<template>
  <div></div>
</template>

<script>
import { getEnvironment, envConfigs } from "@/auth";

export default {
  name: "Home",

  data() {
    return {};
  },

  created: function() {
    this.env = getEnvironment();
    this.config = envConfigs[this.env];
    console.log(this.env, this.config);
  },
  beforeMount: function() {},

  mounted: function() {},

  methods: {},
};
</script>
